import { render, staticRenderFns } from "./WizardStepBasicInfo.vue?vue&type=template&id=6a0854b6&scoped=true&"
import script from "./WizardStepBasicInfo.vue?vue&type=script&lang=js&"
export * from "./WizardStepBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./WizardStepBasicInfo.vue?vue&type=style&index=0&id=6a0854b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0854b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDatePicker,VMenu,VRow,VSelect,VTextField})
